'use client';

import Image from 'next/image';
import {
	VELOCITY_TEXT_LOGO_DARK_SRC,
	VELOCITY_TEXT_LOGO_LIGHT_SRC,
} from 'src/constants/constants';
import { useTheme } from 'next-themes';
import { VelocityTheme } from 'src/environmentVariables/EnvironmentVariableTypes';

export default function PnlModalCardPreviewVelocityLogos() {
	const theme = (useTheme().theme as VelocityTheme) ?? VelocityTheme.dark;
	const src =
		theme === VelocityTheme.light
			? VELOCITY_TEXT_LOGO_LIGHT_SRC
			: VELOCITY_TEXT_LOGO_DARK_SRC;

	return <Image src={src} alt="velocity-text-logo" fill />;
}
